<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Demande d'agrément">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="11">
              <span class="subtitle-1 text-left  font-weight-bold">
                &#187; Votre demande d'agrément est :
              </span>
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio-group v-model="dossier.premiereDemande" row>
                    <v-radio
                      label="Une première demande"
                      name="premiereDemande"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="Un renouvellement"
                      name="premiereDemande"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="11">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; Un pharmacien titulaire associé dans l’officine est-il
                déjà agréé :
              </span>
              <v-row>
                <v-col cols="12" md="2">
                  <v-radio-group v-model="dossier.agree" row>
                    <v-radio
                      label="Oui"
                      name="agree"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="Non"
                      name="agree"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="2">
                  <div v-if="agree">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="agreeDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          id="agree-calendar"
                          v-model="formatedDate"
                          label="Date de l'agrément"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :required="agree"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="agreeDate" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Annuler
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(agreeDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-if="agree"
                v-model="dossier.agreeNom"
                :rules="textRules"
                label="Nom et prénoms du pharmacien maître de stage agréé"
                :required="agree"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";

export default {
  name: "Partie0",
  props: ["dossier"],
  computed: {
    agree: {
      get: function() {
        if (!this.dossier.agree) return false;
        return true;
      },
      set: function(newValue) {
        this.dossier.agree = newValue;
      }
    },
    formatedDate() {
      return this.agreeDate ? moment(this.agreeDate).format("DD/MM/YYYY") : "";
    }
  },
  data: () => ({
    valid: true,
    menu: false,
    agreeDate: null,
    textRules: [v => !!v || "Ce champ est requis"]
  }),
  components: { BaseBlock },
  created() {
    if (this.dossier.agreeDate) {
      let unix_timestamp = this.dossier.agreeDate;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.agreeDate = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.agreeDate = this.agreeDate;
        if (!this.dossier.agree) {
          this.dossier.agreeDate = null;
          this.dossier.agreeNom = null;
        }
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
